import { CoreFileItem } from "./FileCard";

export async function triggerFileDownload(file: CoreFileItem | File) {
	const isNativeFile = file instanceof File;
	const name = file.name;
	const url = isNativeFile ? undefined : file.url;
	const nativeFile = isNativeFile ? file : file.nativeFile;

	if (url) {
		try {
			const response = await fetch(url);
			if (!response.ok) throw new Error("Network response was not ok");

			const blob = await response.blob();
			const blobUrl = URL.createObjectURL(blob);

			const link = document.createElement("a");
			link.href = blobUrl;
			link.download = name;

			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);

			// Clean up
			URL.revokeObjectURL(blobUrl);
		} catch (error) {
			console.error("Failed to download file from URL:", error);
			// Fallback: Try opening in a new tab if fetch fails (e.g., CORS issues)
			window.open(url, "_blank", "noopener,noreferrer");
		}
	} else if (nativeFile) {
		const blobUrl = URL.createObjectURL(nativeFile);
		const link = document.createElement("a");

		link.href = blobUrl;
		link.download = name;

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);

		URL.revokeObjectURL(blobUrl);
	} else {
		console.error("Unable to trigger download: No URL or native file provided.", file);
	}
}

const SUPPORTED_IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "gif", "webp", "svg", "avif"];

export function checkIfImage(fileName?: string): boolean {
	if (!fileName) return false;
	const extension = fileName.split(".").pop()?.toLowerCase();
	return !!extension && SUPPORTED_IMAGE_EXTENSIONS.includes(extension);
}
